import { render, staticRenderFns } from "./SmsSend.vue?vue&type=template&id=5c98af28&"
import script from "./SmsSend.vue?vue&type=script&lang=ts&"
export * from "./SmsSend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports